import { useState, type JSX } from 'react'
import { Settings, ShieldCheck, Wand2 } from 'lucide-react'
import AiConfigPage from './AiConfigPage.js'
import SafetyPanel from '../../components/admin/ai/SafetyPanel.js'
import GenerationPromptsPanel from '../../components/admin/ai/GenerationPromptsPanel.js'

type SubTab = 'ai-config' | 'safety' | 'generation-prompts'

const SUB_TABS: { key: SubTab; label: string; icon: JSX.Element }[] = [
  { key: 'ai-config', label: 'AI Configuration', icon: <Settings className="h-3.5 w-3.5" /> },
  { key: 'safety', label: 'Safety', icon: <ShieldCheck className="h-3.5 w-3.5" /> },
  { key: 'generation-prompts', label: 'Generation Prompts', icon: <Wand2 className="h-3.5 w-3.5" /> },
]

/**
 * Configuration — top-level AI Center page combining the AI Configuration
 * (model routing), Safety & Guardrails, and Generation Prompts screens as
 * sub-tabs, matching the AI Agents page's tab-bar style.
 */
export default function AiConfigurationPage(): JSX.Element {
  const [subTab, setSubTab] = useState<SubTab>('ai-config')

  return (
    <div className="space-y-5">
      {/* Sub-tabs — identical styling to the AI Agents main tab bar */}
      <div className="flex gap-1 border-b border-gray-200">
        {SUB_TABS.map((tab) => (
          <button
            key={tab.key}
            className={`flex items-center gap-1.5 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
              subTab === tab.key
                ? 'border-[#3454cf] text-[#3454cf]'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setSubTab(tab.key)}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      {subTab === 'ai-config' && <AiConfigPage />}
      {subTab === 'safety' && <SafetyPanel />}
      {subTab === 'generation-prompts' && <GenerationPromptsPanel />}
    </div>
  )
}
